/** US dollars, e.g. `$1,234.50`; MFC prices are USD whatever the browser locale */
export const USDollar = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
})

const count = new Intl.NumberFormat('en-US')

/** a count grouped like the USD prices beside it, e.g. `1,875` */
export const formatCount = (value: number) => count.format(value)
